import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { ReserveAction } from '../../../actions/reserve.action';
import { AbstractPage } from '../../_com/abstract-page';
import _ from 'underscore';

/**
 * Generated class for the ReserveEditPhotoRequestMessagePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-reserve-edit-photo-request-message',
  templateUrl: 'reserve-edit-photo-request-message.html',
})
export class ReserveEditPhotoRequestMessagePage extends AbstractPage{

  
  data = {};
  constructor(public navCtrl: NavController, public navParams: NavParams, private reserveAction:ReserveAction, private toastController:ToastController) {
    super();
    this.data = navParams.data;

    if((!this.data["photoRequest"]) || (!this.data["photoRequest"]["message"])){
      _.extend(this.data, {photoRequest:{message:""}});
    }
  }

  /**
   * 写真リクエスト用メッセージ保存
   */
  save(){

      this.reserveAction.updatePhotoRequestMessage(this.data["id"], this.data["photoRequest"]["message"]).subscribe(data=>{
        this.toast(this.toastController, "写真リクエスト用メッセージを更新しました");
        this.navCtrl.pop();
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/photo-request/message-edit/reserve-edit-photo-request-message.ts